module.exports = __webpack_public_path__ + "static/regenerativefarming-c1938c6a44d2424ddda90cbf09d9f277.jpg";